import { render } from "./LayoutMain.vue?vue&type=template&id=b8b09414&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"

import "./LayoutMain.vue?vue&type=style&index=0&id=b8b09414&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b09414"]])

export default __exports__